export const companiesTranslations = {
  ar: {
    title: 'الشركات',
    addNew: 'إضافة شركة جديدة',
    name: 'الاسم',
    taxNumber: 'الرقم الضريبي',
    address: 'العنوان',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    basicInfo: 'البيانات الأساسية',
    contactInfo: 'معلومات الاتصال',
    zatcaInfo: 'بيانات ZATCA',
    financialInfo: 'المعلومات المالية',
    nameOther: 'اسم الشركة (لغة أخرى)',
    addressAr: 'العنوان (عربي)',
    mobile: 'الجوال',
    fax: 'الفاكس',
    url: 'الموقع الإلكتروني',
    nbrTax: 'الرقم الضريبي',
    buildingNo: 'رقم المبنى',
    districtAr: 'الحي',
    cityAr: 'المدينة',
    postalCode: 'الرمز البريدي',
    currency: 'العملة',
    fiscalYearStart: 'بداية السنة المالية',
    fiscalYearEnd: 'نهاية السنة المالية',
    isActive: 'نشط',
    saveSuccess: 'تم إنشاء الشركة بنجاح',
    saveError: 'فشل إنشاء الشركة',
    required: 'هذا الحقل مطلوب',
  },
  en: {
    title: 'Companies',
    addNew: 'Add New Company',
    name: 'Name',
    taxNumber: 'Tax Number',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    basicInfo: 'Basic Information',
    contactInfo: 'Contact Information',
    zatcaInfo: 'ZATCA Information',
    financialInfo: 'Financial Information',
    nameOther: 'Company Name (Other Language)',
    addressAr: 'Address (Arabic)',
    mobile: 'Mobile',
    fax: 'Fax',
    url: 'Website',
    nbrTax: 'Tax Number',
    buildingNo: 'Building Number',
    districtAr: 'District',
    cityAr: 'City',
    postalCode: 'Postal Code',
    currency: 'Currency',
    fiscalYearStart: 'Fiscal Year Start',
    fiscalYearEnd: 'Fiscal Year End',
    isActive: 'Active',
    saveSuccess: 'Company created successfully',
    saveError: 'Failed to create company',
    required: 'This field is required',
  },
  fr: {
    title: 'Entreprises',
    addNew: 'Ajouter une nouvelle entreprise',
    name: 'Nom',
    taxNumber: 'Numéro fiscal',
    address: 'Adresse',
    phone: 'Téléphone',
    email: 'Email',
    basicInfo: 'Informations de base',
    contactInfo: 'Informations de contact',
    zatcaInfo: 'Informations ZATCA',
    financialInfo: 'Informations financières',
    nameOther: 'Nom de l\'entreprise (autre langue)',
    addressAr: 'Adresse (arabe)',
    mobile: 'Mobile',
    fax: 'Fax',
    url: 'Site web',
    nbrTax: 'Numéro fiscal',
    buildingNo: 'Numéro du bâtiment',
    districtAr: 'Quartier',
    cityAr: 'Ville',
    postalCode: 'Code postal',
    currency: 'Devise',
    fiscalYearStart: 'Début de l\'exercice fiscal',
    fiscalYearEnd: 'Fin de l\'exercice fiscal',
    isActive: 'Actif',
    saveSuccess: 'Entreprise créée avec succès',
    saveError: 'Échec de la création de l\'entreprise',
    required: 'Ce champ est requis',
  },
}


